if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    const primaryNav = document.querySelector(".privary-navigation");
	if( primaryNav ){
		const primaryNavList = primaryNav.firstElementChild;

		primaryNavList.removeAttribute("id"); 
		const mid = Math.floor(primaryNavList.children.length / 2);
		const ul = document.createElement("ul"); 
		ul.className = "header__section flex-box a-center";
		const primaryNavGroups = [ 
			[...primaryNavList.children].slice(0, mid), 
			[...primaryNavList.children].slice(mid) 
		];
		primaryNavList.remove();
		primaryNavGroups.forEach(group => { 
			const clonedList = primaryNavList.cloneNode(false); 
			clonedList.append(...group);
			const li = document.createElement("li"); 
			li.classList.add("header__even"); 
			li.append(clonedList);
			ul.append(li); 
		}); 
		primaryNav.append(ul);
	}


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.slick-prev ').html("Prev");

})();